
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/agences",
      function () {
        return require("private-next-pages/en/agences/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/agences"])
      });
    }
  